<template>
  <select :value="modelValue" @input="$emit('update:modelValue', $event.target.value)">
    <option :value="''">Select State</option>
    <option v-for="state in states" :key="state" :value="state">
      {{ state }}
    </option>
  </select>
</template>

<script>
export default {
  props: ['modelValue'],
  emits: ['update:modelValue'],
  setup() {
    return {
      states: [
        'AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO',
        'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU',
        'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY',
        'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN',
        'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
        'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK',
        'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD',
        'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA',
        'WV', 'WI', 'WY',
      ],
    };
  },
};
</script>
